import { Component, Input } from "@angular/core";

@Component({
    selector: "h-shop-info-title",
    templateUrl: "./shop-info-title.component.html",
    styleUrls: ["./shop-info-title.component.scss"],
    standalone: false,
})
export class ShopInfoTitleComponent {
    @Input()
    public headerLevelShopTitle: number = 3;

    @Input()
    public isScreenReaderOnly: boolean = false;
}
